
import ChevronIcon from '~/components/ui/icons/ChevronIcon.vue';
import UIMobileHorizontalPortfolioCard from '@/components/ui/organism/UIMobileHorizontalPortfolioCard.vue';
export default {
  name: 'UIPortfoliosDropdown',
  components: { ChevronIcon, UIMobileHorizontalPortfolioCard },
  props: {
    portfolios: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isPickerVisible: false,
      selectedItem: null,
    };
  },
  created() {
    this.selectedItem = this.portfolios[0] ?? null;
  },
  methods: {
    handleClickOutside() {
      this.isPickerVisible = false;
    },
    handlePortfolioCardClick(selectedPortfolio) {
      this.selectedItem = selectedPortfolio;
      this.isPickerVisible = false;
      this.$emit('onPortfolioChange', selectedPortfolio);
    },
  },
};
